import * as React from 'react';
import './styles.css';
export interface IBaseImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  srcDefault?: string;
  ratio?: '4:3' | '16:9';
  classNameContainer?: string;
  empty?: boolean;
}

export default function BaseImage(props: IBaseImageProps) {
  const { srcDefault, classNameContainer, empty, ratio, ...rest } = props;
  const errorHandler = (e: any) => {
    if (e.target.src !== process.env.REACT_APP_IMG_DEFAULT) {
      e.target.src = process.env.REACT_APP_IMG_DEFAULT;
      e.target.alt = 'Image error';
    }
  };
  if (ratio) {
    return (
      <div
        className={`${classNameContainer} base-image-container w-full`}
        style={{
          paddingBottom: (Number(ratio.split(':')[1]) / Number(ratio.split(':')[0])) * 100 + '%',
        }}
      >
        <img {...rest} onError={errorHandler} />
      </div>
    );
  }

  if (empty && !props.src) {
    return <div className={props.className}></div>;
  }

  return <img {...rest} onError={errorHandler} />;
}
